import makeStyles from '@mui/styles/makeStyles'
import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type DialogElements = {
  content: SxProps
  sendButton: SxProps
  selectProfile: SxProps
  option: SxProps
}

export const useStyles = makeStyles(() => ({
  popper: {
    boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)',
    borderRadius: '4px',
    maxWidth: 'min-content',
    padding: '4px',

    '& .MuiList-root': {
      padding: 0
    }
  }
}))

export const SelectUserDialogStyles: DialogElements = {
  content: {
    margin: 0,
    color: theme.colors.blue03,
    fontFamily: theme.fonts.primaryFont,
    fontSize: '16px',
    lineHeight: '16px',
    whiteSpace: 'pre-wrap',

    '&.MuiDialogContent-root': {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3)
    },

    '& .MuiFormLabel-asterisk': {
      color: theme.colors.red01
    }
  },

  selectProfile: {
    width: '100%',
    padding: 0,

    '& .MuiSelect-select': {
      paddingRight: '44px !important'
    }
  },

  sendButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 24px 24px 24px'
  },

  option: {
    whiteSpace: 'normal',
    color: theme.colors.gray14,
    fontFamily: theme.corporate.secondaryFont,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    minHeight: '38px !important',
    padding: '4px 8px'
  }
}
